/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 14:42:46
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 10:01:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseList/config.tsx
 */
// import { Tag, Image } from 'src/components/Antd';
import GlobalTooltip from '@/src/components/GlobalTooltip/GlobalTooltip';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { DropDown, Menu, MenuItem } from 'src/components/Antd';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { EnumStatus } from 'src/types/common/discount';
import StatusTag from '../../Components/StatusTag';
// import { monent } from 'monent';
import css from './css.module.less';

import {
  getI18nFromGeneral,
  handleOnFormatCurrentSCTimeAndDateWithTimezone,
} from 'src/tools/tools';

const statusFilterList = [
  {
    value: EnumStatus.Active,
    label: getI18nFromGeneral('general.status.active'),
  },
  {
    value: EnumStatus.Draft,
    label: getI18nFromGeneral('general.status.draft'),
  },

  // {
  //   value: IOrderStatus.COMPLETED,
  //   label: getI18nFromGeneral('general.status.completed'),
  // },
  {
    value: EnumStatus.Scheduled, // IOrderStatus.COMPLETE,
    label: getI18nFromGeneral('general.status.scheduled'),
  },
  {
    value: EnumStatus.Expired,
    label: getI18nFromGeneral('general.status.expired'),
  },
];

const switchToDraft = [
  EnumStatus.Active,
  EnumStatus.Scheduled,
  EnumStatus.Expired,
];

export enum StatusChange {
  Publish = 'Publish',
  Archive = 'Archive',
  Restore = 'Restore',
  ToDraft = 'ToDraft',
  Duplicate = 'Duplicate',
}

export enum ModalType {
  ArchiveDiscount = 'ArchiveDiscount',
  UnableToPublish = 'UnableToPublish',
}

const overlay = (data) => (
  <Menu className={css.overlay}>
    {data.map((item) => (
      <MenuItem
        className={`${css.menuItem} ${item.name.toLowerCase()}`}
        disabled={item.disabled}
        key={item.key}
        onClick={() => item.function()}>
        {item.name}
      </MenuItem>
    ))}
  </Menu>
);

export const columns = (
  editFun,
  statusChange,
  statusChangeModal,
  tabsActive,
  scTimezoneUTC,
  disableView,
  disableDelete,
  disableEdit,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelDirectDiscount.list.discountName'),
    dataIndex: 'name',
    key: 'name',
    default: true,
    className: css.columnClass,
    width: 240,
  },
  ...(tabsActive !== EnumStatus.Archived
    ? [
        {
          title: getI18n('general.status'),
          dataIndex: 'status',
          default: true,
          key: 'status',
          className: css.columnClass,
          minWidth: 100,
          sorter: true,
          childGenerate: (text, record) => {
            return <StatusTag status={text} />;
          },
        },
      ]
    : []),
  {
    title: getI18n('general.currency'),
    dataIndex: 'currencyCode',
    key: 'currencyCode',
    default: true,
    className: css.columnClass,
    minWidth: 120,
    sorter: true,
  },
  {
    title: getI18n('salesChannelDirectDiscount.list.promoCode'),
    dataIndex: 'codes',
    default: true,
    key: 'codes',
    className: css.columnClass,
    minWidth: 200,

    childGenerate: (text, record) => {
      return (
        <GlobalTooltip title={text.toString()}>
          <div className={css.codes}>{text.toString()}</div>
        </GlobalTooltip>
      );
    },
  },

  ...(tabsActive !== EnumStatus.Archived
    ? [
        {
          title: `${getI18n('general.startdate')} (UTC ${scTimezoneUTC})`,
          default: true,
          dataIndex: 'beginDateTime',
          key: 'beginDateTime',
          className: css.columnClass,
          minWidth: 180,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <GlobalTooltip
                title={handleOnFormatCurrentSCTimeAndDateWithTimezone(text)}>
                {handleOnFormatCurrentSCTimeAndDateWithTimezone(text)}
              </GlobalTooltip>
            ) : (
              ''
            );
          },
        },
        {
          title: `${getI18n('general.enddate')} (UTC ${scTimezoneUTC})`,
          dataIndex: 'endDateTime',
          default: true,
          key: 'endDateTime',
          className: css.columnClass,
          minWidth: 180,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <GlobalTooltip
                title={handleOnFormatCurrentSCTimeAndDateWithTimezone(text)}>
                {handleOnFormatCurrentSCTimeAndDateWithTimezone(text)}
              </GlobalTooltip>
            ) : (
              ''
            );
          },
        },
      ]
    : []),
  ...(tabsActive === EnumStatus.Archived
    ? [
        {
          title: `${getI18n('general.lastModified')} (UTC ${scTimezoneUTC})`,
          default: true,
          dataIndex: 'modifiedDate',
          key: 'modifiedDate',
          className: css.columnClass,
          minWidth: 232,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <GlobalTooltip
                title={handleOnFormatCurrentSCTimeAndDateWithTimezone(text)}>
                {handleOnFormatCurrentSCTimeAndDateWithTimezone(text)}
              </GlobalTooltip>
            ) : (
              ''
            );
          },
        },
        {
          title: `${getI18n('general.status.archived')} (UTC ${scTimezoneUTC})`,
          dataIndex: 'archivedAt',
          default: true,
          key: 'archivedAt',
          className: css.columnClass,
          sorter: true,
          minWidth: 240,
          childGenerate: (text, record) => {
            return text ? (
              <GlobalTooltip
                title={handleOnFormatCurrentSCTimeAndDateWithTimezone(text)}>
                {handleOnFormatCurrentSCTimeAndDateWithTimezone(text)}
              </GlobalTooltip>
            ) : (
              ''
            );
          },
        },
      ]
    : []),
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'actions',
    default: true,
    key: 'actions',
    className: css.columnClass,
    minWidth: 128,
    align: 'center',
    childGenerate: (text, record) => {
      const overlayActionNoDraftList = overlayActionNoDraft(
        record.status,
        record.uuid,
        editFun,
        statusChange,
        !record.hasError,
        statusChangeModal,
        disableView,
        disableDelete,
        disableEdit,
        { getI18n },
      );
      return (
        <DropDown
          overlay={overlay(overlayActionNoDraftList)}
          getPopupContainer={() => document.body}
          placement='bottomRight'
          trigger={['click']}>
          <div className={css.moreActions}>
            <Icon type='iconMore'></Icon>
          </div>
        </DropDown>
      );
    },
  },
];

const overlayActionNoDraft = (
  type,
  uuid,
  editFun,
  statusChange,
  canPublish,
  statusChangeModal,
  disableView,
  disableDelete,
  disableEdit,
  { getI18n },
) => [
  {
    name: getI18n('general.edit'),
    key: 1,
    function: () => editFun(uuid, false),
    disabled: disableView,
  },
  // ...(type !== EnumStatus.Archived
  //   ? [
  //       {
  //         name: 'Duplicate',
  //         key: 2,
  //         function: () => statusChange([uuid], StatusChange.Duplicate),
  //         disabled: disableEdit,
  //       },
  //     ]
  //   : []),

  ...(type == EnumStatus.Draft
    ? [
        {
          name: getI18n('general.publish'),
          key: 3,
          function: () =>
            statusChange([uuid], StatusChange.Publish, canPublish),
          disabled: disableEdit,
        },
      ]
    : []),
  ...(switchToDraft.includes(type)
    ? [
        {
          name: getI18n('general.switchToDraft'),
          key: 4,
          function: () => statusChange([uuid], StatusChange.ToDraft),
          disabled: disableEdit,
        },
      ]
    : []),
  ,
  ...(type !== EnumStatus.Archived
    ? [
        {
          name: getI18n('general.archive'),
          key: 5,
          function: () => statusChangeModal([uuid], ModalType.ArchiveDiscount),
          disabled: disableDelete,
        },
      ]
    : []),
  ...(type == EnumStatus.Archived
    ? [
        {
          name: getI18n('general.restore'),
          key: 6,
          function: () => statusChange([uuid], StatusChange.ToDraft),
          disabled: disableEdit,
        },
      ]
    : []),
];

export const breadcrumbData = (
  salesChannelUuid,
  salesChannelName,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: `/${salesChannelUuid}`,
    name: salesChannelName,
  },
  {
    url: '',
    name: getI18n('salesChannelDirectDiscount.list.discount'),
  },
  {
    url: '',
    name: getI18n('general.sider.giftPurchase'),
  },
];

export const tabsConfig = ({ getI18n }) => {
  const i18n = getI18n
    ? getI18n
    : () => {
        return;
      };
  return [
    //定义tabs列表
    { name: i18n('general.all'), key: '' },
    {
      name: i18n('salesChannelDirectDiscount.list.auto'),
      key: EnumStatus.Auto,
    },
    {
      name: i18n('salesChannelDirectDiscount.list.promoCode'),
      key: EnumStatus.PromoCode,
    },
    { name: i18n('general.archive'), key: EnumStatus.Archived },
  ];
};

export const filterList = ({ getI18n }) => [
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: { name: getI18n('general.status') },
    keyWord: 'discountStatuses',
    options: statusFilterList.map((item) => ({
      label: item.label,
      value: item.value,
    })),
  },
];
